import { createActionGroup, props } from '@ngrx/store';
import { CategoryType, ErrorModel } from '@rocksoft/shared';
import { ApplicationConfiguration } from './category-applications.state';

// ============================================================================
// API ACTIONS
// ============================================================================

export const ApplicationsApiActions = createActionGroup({
  source: 'Applications API',
  events: {
    'Category application configurations updated error': props<{
      id: string;
      categoryType: CategoryType;
      error: ErrorModel;
    }>(),
  },
});

// ============================================================================
// VIEW ACTIONS
// ============================================================================

export const CategoryApplicationViewActions = createActionGroup({
  source: 'Category application view',
  events: {
    'Application configurations updated': props<{
      id: string;
      categoryType: CategoryType;
      previousApplicationsLinkedToCategory: ApplicationConfiguration[];
      updatedApplicationsLinkedToCategory: ApplicationConfiguration[];
    }>(),
  },
});
